import { render } from "./App.vue?vue&type=template&id=5b1808cd"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5b1808cd&lang=scss"
script.render = render

export default script